let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f9kIh")).then(() => parcelRequire('6bTwW'));